import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Dropdown, Tooltip } from 'antd';

// Shared UI Library Components
import { CustomIcon, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './aside-menu.scss';

// Config
import { CBusinessProfileMenuList } from '../../../../configs/components/business-profile.config';

type TAsideMenuProps = {
  pathState: {
    current: string;
    prev: string;
  },
}

export const AsideMenu: FC<TAsideMenuProps> = (
  { pathState: { current: currentPath } }: TAsideMenuProps
): JSX.Element => {

  const navigate = useNavigate();

  const navigateToCounsellorSubPage = (path: string): void => {
    navigate(`/${ path }`);
  }

  return (
    <div className="aside-menu">
      <div className="aside-menu--list">
        {
          CBusinessProfileMenuList.map(({ icon, path, activeIcon, label }) => {
            const isActive = currentPath === path;
            return (
              <Tooltip key={ Math.random() } placement={ 'right' } title={ label }>
                <div
                  className={ `aside-menu--item ${ isActive ? ' active-item' : '' }` }
                  onClick={ () => navigateToCounsellorSubPage(path) }>
                  <span className="icon-item">{ isActive ? activeIcon : icon }</span>
                  <span className="text-item">{ label }</span>
                </div>
              </Tooltip>
            )
          })
        }
      </div>

      <div className="aside-menu--actions">
        <Dropdown menu={ {
          items: CBusinessProfileMenuList.map(({ icon, path, activeIcon, label }) => ({
            key: Math.random(),
            label: <Tooltip key={ Math.random() } placement={ 'right' } title={ label }>
              <div
                className={ `aside-menu--item ${ currentPath === path ? ' active-item' : '' }` }
                onClick={ () => navigateToCounsellorSubPage(path) }>
                <span className="icon-item">{ currentPath === path ? activeIcon : icon }</span>
                { label }
              </div>
            </Tooltip>
          }))
        } } trigger={ ['click'] } placement="bottomLeft" arrow>
          <CustomIcon name={ EIconName.BurgerMenu }/>
        </Dropdown>
      </div>
    </div>
  )
};
